export const FETCH_QUERY_KEYS = {
  DASHBOARD_SETTINGS: "dashboardSettings",
  ADMIN_ROLES: "adminRoles",
  COLLECTIONS: "collections",
  COLLECTION: "collection",
  KNOWLEDGE_SOURCE_INSTANCES: "knowledgeSourceInstances",
  ASSISTANT_AVAILABLE_DATA: "collectionAvailableData",
  ASSISTANT_LANGUAGES: "assistantLanguages",
  ASSISTANT_DEFAULT_SETTINGS: "defaultSettings",
  COLLECTION_REFS: "collectionRefs",
  ASSISTANT: "assistant",
  ACCOUNT_ASSISTANTS: "accountAssistants",
  DRAFT: "draft",
  EXTERNAL_PREVIEW: "externalPreview",
  EXTERNAL_PREVIEW_LINK: "externalPreviewLink",
  INSIGHTS: "insights",
  ANALYTICS_OVERVIEW: "analyticsOverview",
  ANALYTICS_OVERVIEW_ROUTES: "analyticsOverviewRoutes",
  ANALYTICS_OVERVIEW_INSIGHTS: "analyticsOverviewInsights",
  AUTOMATION_POTENTIAL_NOTIFICATION: "automationPotentialNotification",
  ANALYTICS_OVERVIEW_SITES: "analyticsOverviewSites",
  ANALYTICS_SAVED_FILTERS: "analyticsSavedFilters",
  DATA_FRESHNESS: "dataFreshness",
  CHAT_OVERVIEW: "chatOverview",
  SIGMA_DASHBOARD_TABS: "sigmaDashboardTabs",
  SIGMA_EMBED_URL: "sigmaEmbedUrl",
  CHAT_INTENT_VOLUME: "chatIntentVolume",
  CHAT_INTENT_BREAKDOWN: "chatIntentBreakdown",
  ACCOUNT_ANALYTICS_OVERVIEW: "accountAnalyticsOverview",
  ACCOUNT_ANALYTICS_OVERVIEW_ROUTES: "accountAnalyticsOverviewRoutes",
  // eslint-disable-next-line no-secrets/no-secrets
  ACCOUNT_ANALYTICS_OVERVIEW_INSIGHTS: "accountAnalyticsOverviewInsights",
  ACCOUNT_ANALYTICS_SENTIMENT_BUCKETS: "accountAnalyticsSentimentBuckets",
  ACCOUNT_DETAILS: "accountDetails",
  CHAT_OVERVIEW_INSIGHTS: "chatOverviewInsights",
  SENTIMENT_SUMMARY: "sentimentSummary",
  SENTIMENT_ROUTES: "sentimentRoutes",
  SENTIMENT_BUCKETS: "sentimentBuckets",
  SCHEDULING_KPIS: "schedulingKpis",
  // eslint-disable-next-line no-secrets/no-secrets
  SCHEDULING_EXIT_REASONS_BREAKDOWN: "schedulingExitReasonsBreakdown",
  ACTIONABLE_INSIGHTS: "insightsHomeBanner",
  ASSISTANT_TEMPLATES: "assistantTemplates",
  SUPPORTED_LANGUAGES: "supportedLanguages",
  PHONE_NUMBERS_METADATA: "phoneNumbersMetadata",
  PERMISSIONS: "permissions",
  CAMPAIGN_MANAGER: "campaignManager",
  CAMPAIGN_MANAGER_TASKS: "campaignManagerTasks",
  ALL_CAMPAIGNS: "allCampaigns",
  CAMPAIGN: "campaign",
  CAMPAIGN_DATA_PROCESSOR: "campaignDataProcessor",
  DATA_PROCESSOR_CONFIG: "dataProcessorConfig",
  OUTBOUND_FILTER_TYPES: "outboundFilterTypes",
  AGENT_SKILLS: "agentSkills",
  CONVERSATION_INSIGHTS: "conversationInsights",
  CONVERSATION_UTTERANCE_COUNT: "conversationUtteranceCount",
  VALIDATION_RESULTS: "validationResults",
  VERTICAL_TYPES: "verticalTypes",
  ALL_ASSISTANTS_DATA: "allAssistantsData",
  OPEN_DRAFTS: "openDrafts",
  DRAFT_OWNERS: "draftOwners",
  FAILURES: "failures",
  POLICIES_LINKED_DATA: "policiesLinkedData",
  ASSISTANT_KNOWLEDGE: "assistantKnowledge",
  DATA_MAPPINGS_TABLES: "dataMappingsTables",
  DATA_MAPPING_TABLE: "dataMappingTable",
  ASSISTANT_CONFIGURATION: "assistantConfiguration",
  EARCON_TYPES: "earconTypes",
  DEPLOYMENT_SETTINGS: "deploymentSettings",
  PREVIEW_BRANCH_DEPLOYER: "previewBranchDeployer",
  GENERATE_SPEECH: "generateSpeech",
  CHANNEL_SETTINGS: "channelSettings",
  EVENTS_VALUE_OPTIONS: "eventsValueOptions",
  SFTP_SETTINGS: "sftpSettings",
  ACCOUNT_SETTINGS: "accountSettings",
  ACCOUNT_SETTINGS_SFTP: "accountSettingsSftp",
  CALL_ME_SITES: "callMeSites",
  CALL_ME_BUSINESS_HOURS: "callMeBusinessHours",
  FEATURE_ADOPTION: "featureAdoption",
  FEATURE_AGENTS: "featureAgents",
  AGENT_FEATURES: "agentFeatures",
  SUBSCRIPTION: "subscription",
  ALL_SUBSCRIPTIONS: "allSubscriptions",
  SUBSCRIPTION_USAGE_OVER_TIME: "subscriptionUsageOverTime",
  EXPRESSION_VARIABLES: "expressionVariables",
  CONFIGURABLE_CONTENT: "configurableContent",
  EXPLORE_INTROSPECTION: "exploreIntrospection",
  EXPLORE_VERSIONS: "exploreVersions",
  EXPLORE_DATA: "exploreData",
  EXPLORE_FIELD_VALUES: "exploreFieldValues",
  BENCHMARKS_SETUP: "benchmarksSetup",
  ALL_SETUPS: "allSetups",
  BENCHMARK_DEFAULTS: "benchmarkDefaults",
  BENCHMARK_OVERRIDES: "benchmarkOverrides",
  VALUE_REFERENCE_DEFAULTS: "valueReferenceDefaults",
  VALUE_REFERENCE_OVERRIDES: "valueReferenceOverrides",
  CLINIC_AVAILABILITY: "clinicAvailability",
  CLINIC_AVAILABILITY_VALIDATE: "clinicAvailabilityValidate",
  SCHEDULED_REPORTS: "scheduledReports",
  DATA_PROCESSORS: "dataProcessors",
  DATA_PROCESSOR: "dataProcessor",
  DATA_PROCESSOR_SKILL_FIELDS: "dataProcessorSkillFields",
  FEATURES: "features",
  TRACKED_CONFIGS: "trackedConfigs",
  DUPLICATE_TARGET_ACCOUNTS: "duplicateTargetAccounts",
  DUPLICATE_AGENT_NAME_AVAILABILITY: "duplicateAgentNameAvailability"
};
